import React from "react";
import { SectionIndicator } from "../sectionIndicator/SectionIndicator";
import { TCText } from "../TCText/TCText";

type props = {
  children: React.ReactNode;
  indicator: number;
  title: string;
};

export const SectionBackground: React.FC<props> = ({
  children,
  indicator,
  title,
}) => {
  return (
    <div
      style={{
        height: "100%",
        backgroundColor: "white",
        borderRadius: 20,
        padding: 20,
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}>
        <SectionIndicator number={indicator.toString()} />
        <TCText
          style={{ fontWeight: 600, textAlign: "center", fontSize: 14 }}
          value={title}
        />
      </div>
      {children}
    </div>
  );
};
